export const actions = {
  set: 'SET::MENU_ACTIVE_STATE'
}

export const setMenuActiveState = state => ({ type: actions.set, menuState: state })
export const getMenuActiveState = state => state.menuState

export default actions



// WEBPACK FOOTER //
// ./src/store/menu-state/actions.js